import { Tooltip, Flex, Icon, Button, Text } from "@appsmith/ads";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  gap: var(--ads-v2-spaces-4);
  justify-content: space-between;
`;

const AnnotatedLabel = styled(Text)`
  text-decoration-line: underline;
  text-decoration-style: dotted;
  text-decoration-color: var(--ads-v2-color-border-emphasis);
  text-underline-offset: var(--ads-v2-spaces-1);
`;

interface HeaderProps {
  showAddActionsButton: boolean;
  onAddActionsButtonClick: () => void;
}

export const Header = (props: HeaderProps) => {
  const { onAddActionsButtonClick, showAddActionsButton } = props;

  return (
    <Container>
      <Tooltip
        align={{
          points: ["cr", "cl"],
          offset: [0, 2],
        }}
        content="Integrations allow the agent to intelligently fetch data, perform actions, and generate accurate, real-time responses."
      >
        <Flex alignItems="center" flexDirection="row" gap="spaces-2">
          <AnnotatedLabel isBold kind="heading-s" renderAs="p">
            Integrations
          </AnnotatedLabel>
          <Icon name="info" size="md" />
        </Flex>
      </Tooltip>
      {showAddActionsButton && (
        <Button
          UNSAFE_width="110px"
          kind="secondary"
          onClick={onAddActionsButtonClick}
          startIcon="plus"
        >
          Add actions
        </Button>
      )}
    </Container>
  );
};
